import { createRouter, createWebHistory } from 'vue-router';
import Appointments from '../components/Appointments.vue';

const Portal = () => import(/* webpackChunkName: "about" */ '../views/Portal.vue');

const routes = [
  {
    path: '/',
    redirect: '/portal',
  },
  {
    path: '/portal',
    name: 'Portal',
    meta: {
      requiresAuth: true,
    },
    component: Portal,
  },
  {
    path: '/portal/scheduler',
    name: 'Scheduler',
    meta: {
      requiresAuth: true,
    },
    component: Portal,
  },
  {
    path: '/portal/pod-schedule',
    name: 'PodSchedule',
    meta: {
      requiresAuth: true,
    },
    component: Portal,
  },
  {
    path: '/portal/appointments',
    name: 'Appointments',
    component: Appointments,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
